/**
 * The cross-window nudge (ADR-0110): after a write to a game's log on disk,
 * the other windows on that game are told to read it again. The message is the
 * game id and nothing else; the disk stays the only source of truth.
 */

import { broadcast } from '@good-season/platform';

/** The channel a write is announced on. */
export const WRITES = 'good-season-scorebook-writes';

/** Tell the other windows on this game that its log on disk may have changed. */
export function announceWrite(gameId: string): void {
  broadcast.post(WRITES, gameId);
}
